<template>
  <div class="clearfix">
    <AUpload
      :customRequest="uploadFile"
      list-type="picture-card"
      :accept="accept"
      :file-list="filterFileList"
      :supportServerRender="true"
      :previewFile="thumbPreview"
      @preview="handlePreview"
      @change="handleChange"
    >
      <div v-if="fileList.length < limit">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          点击上传
        </div>
      </div>
    </AUpload>
    <p class="color999">* 最多上传{{limit}}张图片</p>
    <AModal class="preview-modal" :visible="previewVisible" @cancel="handleCancel" title="图片预览">
      <div class="preview-container">
        <img :src="`${previewImage}`"/>
      </div>
      <template #footer>
        <div class="flex flex-center">
          <AButton type="primary" @click="rotateImg(270)"><a-icon type="undo" />向左旋转90°</AButton>
          <AButton type="primary" @click="rotateImg(90)">向右旋转90°<a-icon type="redo" /></AButton>
        </div>
      </template>
    </AModal>
  </div>
</template>
<script>
import ImageCompressor from "image-compressor.js"
import { uploadFile, rotateImg } from '@api'
// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });
// }
export default {
  props: {
    /** 限制文件类型 */
    accept: {
      type: String,
      default: "*"
    },
    /** 限制上传数量 */
    limit: {
      type: Number,
      default: 5
    },
    fileList: {
      type: Array,
      require: true,
    }
  },
  data() {
    return {
      //通过改变这个值刷新获取最新的原图
      previewKey: 0,
      previewVisible: false,
      previewFile: '',
      // fileList: [],
    };
  },
  computed:{
    previewImage(){
      return `${this.serverUrl(this.previewFile.url)}?key=${this.previewKey}`
    },
    filterFileList(){
      this.fileList.forEach(item => {
        if(!item.uid) item.uid = this.$publicJs.guid()
        if(!item.status) item.status = 'done'
        if(!item.thumbUrl) item.thumbUrl = this.serverUrl(item.url)
      })
      return this.fileList
    }
  },
  created(){
  },
  methods: {
    async uploadFile(param){
      let file = param.file
      //压缩图片
      let compressorFile = await this.imgCompressor(param.file)
      if(!compressorFile) return
      try {
        let { data } = await uploadFile({file: compressorFile})
        let targetFile = this.fileList.find(item => item.uid == file.uid)
        targetFile.status = 'done'
        targetFile.url = data
        targetFile.thumbUrl = this.serverUrl(data)
      } catch (e){
        let index = this.fileList.findIndex(item => item.uid == file.uid)
        if(index > -1){
          this.fileList.splice(index, 1)
        }
        return false
      }
      return true
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      this.previewFile = file
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      //清空list
      this.fileList.splice(0, this.fileList.length)
      //重新push
      this.fileList.push(...fileList)
      // this.fileList = fileList;
    },
    /** 获取文件路径和名称列表 */
    getFileList(){
      return this.fileList.map(item => {
        return {
          url: item.url,
          name: item.name
        }
      })
    },
    //缩略图预览
    thumbPreview(file){
      console.log('file', file)
    },
    /** 压缩图片 */
    async imgCompressor(file){
      if (!file) {
        return
      }
      const imageCompressor = new ImageCompressor();
      try {
        let res = await imageCompressor.compress(file, {
          checkOrientation: false,
          maxHeight: 1700,//最大高度
          maxWidth: 1700//最大宽度
        })
        return new window.File([res], file.name, {type: file.type})
      } catch (e) {
        this.$message.error("图片压缩失败，请重新上传！")
      }
    },
    //图片的服务器全路径
    serverUrl(uploadUrl){
      return `${this.$config.serverUrl}${uploadUrl}`
    },
    /** 旋转图片 */
    async rotateImg(angle){
      await rotateImg({uploadPath: this.previewFile.url, angle})
      this.previewKey++
      this.previewFile.thumbUrl = this.previewImage
    }
  },
  watch: {
    fileList(){
      console.log(this.fileList)
    }
  }
};
</script>
<style lang="less">
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.preview-modal{
  .ant-modal{
    width: max-content !important;
    .preview-container{
      @size: 50vh !important;
      width: @size;
      height: @size;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
}

</style>
